export default "__VITE_ASSET__aba69779__"